import { createApi } from "@reduxjs/toolkit/query/react";
import { API_ENDPOINTS } from "../../Constants/endpoints";
import {
  QuickQuoteResponse,
  QuickQuoteRequest,
  CreateQuoteRequest,
  CreateQuoteResponse,
  PaymentRequest,
  PaymentResponse,
  HealthListingResponse,
  HealthListingRequest,
  HealthPaymentStatusResponse,
  HealthSaveDraftRequest,
  ValidatePhoneNumberRequest,
  validatePhoneNumberResponse,
} from "../../Interfaces/general";
import { baseUrlQuery } from "./baseQuery";

export const quotesApi = createApi({
  reducerPath: "quotesApi",
  baseQuery: baseUrlQuery,
  endpoints: (builder) => ({
    quickQuote: builder.mutation<QuickQuoteResponse, QuickQuoteRequest>({
      query: (body: QuickQuoteRequest) => ({
        url: API_ENDPOINTS.QUICK_QUOTE,
        method: "POST",
        body: body,
      }),
      // transformResponse: (response: { data: QuickQuoteResponse }) =>
      //     response.data,
    }),
    createQuote: builder.mutation<CreateQuoteResponse, CreateQuoteRequest>({
      query: (body: CreateQuoteRequest) => ({
        url: API_ENDPOINTS.CREATE_QUOTE,
        method: "POST",
        body: body,
      }),
    }),
    payment: builder.mutation<PaymentResponse, PaymentRequest>({
      query: (body: PaymentRequest) => ({
        url: API_ENDPOINTS.PAYMENT,
        method: "POST",
        body: body,
      }),
    }),
    getHealthListing: builder.query<
      HealthListingResponse,
      HealthListingRequest
    >({
      query: ({ urn_number, status }) => ({
        url: API_ENDPOINTS.HEALTH_LISTING,
        method: "GET",
        params: {
          urn_number,
          status
        },
      }),
    }),
    getHealthPaymentStatus: builder.query<
      HealthPaymentStatusResponse,
      HealthListingRequest
    >({
      query: ({ urn_number }) => ({
        url: API_ENDPOINTS.HEALTH_PAYMENT_STATUS,
        method: "GET",
        params: {
          urn_number,
        },
      }),
    }),
    getHealthDraftEmail: builder.query<{}, HealthSaveDraftRequest>({
      query: ({ order_id, is_draft }) => ({
        url: API_ENDPOINTS.HEALTH_DRAFT_EMAIL,
        method: "GET",
        params: {
          order_id,
          is_draft,
        },
      }),
    }),
    validatePhoneNumber: builder.mutation<validatePhoneNumberResponse, ValidatePhoneNumberRequest>({
      query: ({phone_number}) => ({
        url: API_ENDPOINTS.VALIDATE_PHONE_NUMBER,
        method: "POST",
        body: { phone_number },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token 64591335a441dd13cd179de5e37373668d0be449`,
        },
      }),
    }),
  }),
});

export const {
  useQuickQuoteMutation,
  useCreateQuoteMutation,
  usePaymentMutation,
  useLazyGetHealthListingQuery,
  useLazyGetHealthPaymentStatusQuery,
  useLazyGetHealthDraftEmailQuery,
  useValidatePhoneNumberMutation
} = quotesApi;
